import { accessAuto1, accessAutoThumb, accesscontrollerThumb, accessLiteThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import {
  accessKey1,
  accessOutlook,
  IconBattery,
  IconBluetooth,
  IconBox,
  IconComputer,
  IconCard,
  IconFacetime,
  IconGuarantee,
  IconQR,
  IconTemp,
  IconUsbc,
  IconWarn,
  IconWaterproof,
  IconCamera,
  IconZoom,
  IconTopology,
  IconEhternet,
  IconRoute2,
  IconUserCheck2,
  IconSearchGray,
  IconEnergyCircleGray,
  IconLinkChainGray,
} from '@assets/images/main/index';
import { bell1, esl1, idCard1, mCradle1, mCradleThumb, mTagThumb, switch1 } from '@assets/images/main/iot/product';
import {
  aoaEnterpriseKitThumb,
  aoaStarterKitThumb,
  assetTracking2,
  bleEnterpriseKit,
  bleStarterKit,
  bleStarterKit2,
  bleStarterKit3,
  comfortKitThumb,
  tagUwb1,
  twinTracker6,
  twinTrackerAoa1,
  twinTrackerAoa3,
  twinTrackerAoaThumb,
  twinTrackerBracket,
  uwbEnterpriseKitThumb,
  uwbStarterKitThumb,
} from '@assets/images/main/rtls/product';
import {
  IconAnalytics,
  IconAnalyticsGray,
  IconAppsLineGray,
  IconAtomGray,
  IconBinocularsGray,
  IconCar,
  IconCarGray,
  IconChainLink,
  IconChainLinkGray,
  IconCheck,
  IconCheckBlack,
  IconCodeGray,
  IconEnergyCircle,
  IconEyeline,
  IconInfo,
  IconLayerGray,
  IconLocation,
  IconLocationGray,
  IconMail,
  IconMonitorLineGray,
  IconPhone,
  IconPower,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSignal,
  IconSunGray,
  IconThumbUp,
  IconTools,
  IconToolsGray,
  IconTvocGray,
  IconUserCheck,
  IconUwbGray,
  IconWifi,
  IconZoneGray,
} from '@assets/images/icon';
import {
  accessKeyThumbnail,
  accessproThumbnail,
  deadboltThumbnail,
  emlockThumbnail,
  eslThumbnail,
  orbroServerThumbnail,
  safetyBellThumbnail,
  switchThumbnail,
  twinTrackerThumbnail,
} from '@assets/images/main/thumbnail';
import { enterpriseKit1, ipCamReverse, ipThumb, ptzThumb, starterKit2, starterKit3, starterKit4 } from '@assets/images/main/camera';
import { airQuality1, coMeasure1, loraGateway1, loraSensor1 } from '@assets/images/main/sensor';
import { coinTagThumb, orbroTag1, orbroTagThumb, plutoconPro1, plutoconProThumb, slimTagThumb, stickerTagThumb } from '@assets/images/main/beacon/product';
import { assetTag1 } from '@assets/images/main/beacon/product';
import { cobot1, deliverPackage, deliverRobot1, disinfection1, disinfection2, loadingKiosk1, loadingKiosk2 } from '@assets/images/main/integration';
import { IconCctvOff, IconCctvOn } from '@assets/images/main/icon';
import { vehicleTrackingKitThumb, yardTrackingKitThumb } from '@assets/images/main/outdoor';
import { osServer1 } from '@assets/images/main/os/product';

export default {
  purchaseDesc: {
    mobile: '内置电池的产品,无需电源工程,可贴在出入门旁边,方便快捷地用手机控制出入门。',
    auto: '这是一款专门用于出入自动门的产品通过更换现有的自动门传感器后安装应用程序，实现非接触式出入。',
    lite: '这是一款基于 NFC 和 BLE 的轻量级门禁读卡器，可通过智能手机和门禁卡实现出入。',
    face: 'Access Pro是具有控制门厅门禁、呼叫功能的产品。用该产品呼叫用户，用户就可以通过手机应用程序进行视频通话，还可以远程控制门禁。并且可以使用NFC卡和密码解锁，是代替现有门厅门禁的最佳产品。',
    accessory: '',

    asset: '将BLE标签设备附着到您要监视或追踪的对象，实现实时位置追踪。',
    worker: '将UWB标签设备附着到您要监视或追踪的对象，实现实时位置追踪。',

    outdoor: '通过PTZ户外摄像机追踪停车场车辆的位置。',
    indoor: '通过摄像机分析室内人员的移动路径。',
    monitoring: 'Safety Bell是一款可以在任何具有Wi-Fi的地方轻松安装和立即使用的产品。',

    energy: 'Smart Switch是可以轻松将普通开关更换为智能开关的产品。',
    display: 'ESL是基于信标系统的显示设备。 因为使用了E-ink Display，所以可以以非常低的电力使用显示器。',
    cradle: '可以无线管理智能手机,不会给电缆锁定装置带来不便。',
    idCard: '员工证是以挂绳形式制作，可在工业和服务领域都能高度兼容地使用。可以与欧博罗 RTLS 系统以及蓝牙系统进行联动。',

    osServer: 'ORBRO Server 是内置 ORBRO OS 的后端服务器，支持室内定位与移动轨迹记录，提供稳定的数据处理与快速响应。',
    osRtls: 'ORBRO Edge RTLS 是一款支持 1GbE 连接的紧凑型桌面设备，采用 ORBRO TDoA 算法实现高精度 UWB 跟踪功能。',
    osAi: '该智能解决方案利用摄像头画面实现定位与人数统计功能，可通过 RTSP 或 PoE 连接视频数据，无需 ORBRO Server 也可独立运行。',
    osSwitch: 'ORBRO 专用的 8 端口 L2 交换机，支持 1Gb 上行和 40W PoE，并可通过应用或网页监控和管理连接的 PoE 设备状态。',

    server: '一款企业级服务器套件，利用 AI 视频分析支持大规模对象位置跟踪与现场感知。',
    edge: '利用摄像头画面进行定位与人数统计的智能解决方案，通过 RTSP 或 PoE 连接，无需 ORBRO Server 即可独立运行。',

    ble: '可将 BLE 标签设备附着于资产或人员上进行位置跟踪。',
    aoa: 'TwinTracker AoA 是基于 AoA（到达角）技术的固定锚点设备，支持高精度室内定位。',
    uwb: '可将 UWB 标签设备附着于资产或人员上进行位置跟踪。',
    comfort: '无需额外基础设施，仅通过手机即可实时查看使用 UWB 标签的对象位置的便携式跟踪工具。',

    gps: '基于 GNSS 的定位设备，精度可达 3 米，支持每分钟最多 10 次数据传输、USB-C 接口、最长 150 天使用时间。',
    lora: '该室外套件可在大范围内接收 GNSS 跟踪标签的 LoRa 信号，并通过 PoE 实时传输到 ORBRO Server。',

    loraGateway: 'ALESS_GW设备是一种为工业环境优化的智能无线通信集中器，可作为智能无线网关，将传感器数据传输到网络服务器。',
    loraSensor: '此产品与现场所需的各种传感器（如温度传感器、压力传感器、泄漏传感器、湿度传感器等）进行接口。它通过无线通信测量传感器数据并进行传输。',
    airQuality:
      '高精度空气质量监测仪内置微粒物、二氧化碳、挥发性有机化合物、温度和湿度传感器。它在显示屏上实时显示每个传感器值的测量，并可与服务器系统集成以进行数据监测。',
    coMeasure: '除一氧化碳外，它还内置了测量微粒物（PM1.0/PM2.5/PM4.0/PM10）、温度和湿度的传感器，实时测量数据。',

    beaconIndustry: '支持防水和防尘，经过工业验证，可使用长达3年。',
    beaconTag: '可以附在任何地方的小型标签信标终端。',
    assetTag: '用于资产管理的超小型蓝牙标签终端',
  },

  purchase: {
    mobile: {
      accesscontroller: {
        icon: accessKey1,
        title: 'Access Controller',
        serial: 'KB-BK02',
        price: '50,000',

        note: [
          { text: '支持通过手机实现非接触出入功能', icon: IconInfo },
          { text: '最新版本的蓝牙技术', icon: IconBluetooth },
          { text: '精确的10米范围内出入管理', icon: IconWarn },
          { text: `IP65级的防水防尘（-10~40°C）`, icon: IconWaterproof },
          { text: '最长3年电池使用时间', icon: IconBattery },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: '磁性门锁',
            price: '150,000',
            img: deadboltThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: accesscontrollerThumb,
            title: 'Access Controller',
            price: '50,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    //자동문 출입
    auto: {
      accessauto: {
        icon: accessKey1,
        title: 'Access Auto',
        serial: 'OAC-AUBT5091',
        price: '150,000',

        note: [
          { text: '支持通过手机实现非接触出入功能', icon: IconInfo },
          { text: '最新版本的蓝牙技术', icon: IconBluetooth },
          { text: '精确的2米范围内出入管理', icon: IconWarn },
          { text: '0 ~ 50°C工作温度', icon: IconTemp },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: '磁性门锁',
            price: '150,000',
            img: deadboltThumb,
          },
          {
            title: '室内自动门传感器',
            price: '99,000',
            img: accessAutoThumb,
          },
        ],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: accessAutoThumb,
            title: 'Access Auto',
            price: '150,000',
            min: 1,
            max: 999,
          },
        ],
      },
      apart: {
        icon: accessOutlook,
        title: '公寓套餐',
        serial: 'Access Auto 20 + Server 1',
        price: '5,000,000',

        note: [
          { text: '支持通过手机实现非接触出入功能', icon: IconInfo },
          { text: '包含ORBRO OS的ORBRO服务器', icon: IconComputer },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: '磁性门锁',
            price: '150,000',
            img: deadboltThumb,
          },
          {
            title: '室内自动门传感器',
            price: '99,000',
            img: accessAutoThumb,
          },
        ],

        options: [],
        mark: '',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '2,000,000',
            min: 1,
            max: 999,
          },
          {
            img: accessAutoThumb,
            title: 'Access Auto',
            price: '150,000',
            min: 20,
            max: 999,
          },
        ],
      },
      cloud: {
        icon: accessOutlook,
        title: 'Access Auto (Cloud)',
        serial: 'OAC-AUBT5091',
        price: '29,000',
        priceSub: '/月',

        note: [
          { text: '支持通过手机实现非接触出入功能', icon: IconInfo },
          { text: '最新版本的蓝牙技术', icon: IconBluetooth },
          { text: '精确的2米范围内出入管理', icon: IconWarn },
          { text: '0 ~ 50°C工作温度', icon: IconTemp },
          { text: '1年质保期', icon: IconGuarantee },
        ],
        parts: [],
        options: [],
        mark: '1',

        mainProduct: [
          {
            img: accessAutoThumb,
            title: 'Access Auto (Cloud)',
            price: '29,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    // 人脸识别门禁
    lite: {
      accessLite: {
        title: 'Access Lite',
        serial: 'OAC-LGBT0001',
        price: '700,000',

        note: [
          { text: '提供基于 NFC·BLE 的智能手机与门禁卡通行功能', icon: IconInfo },
          { text: '通过 PoE 实现通信与供电一体化', icon: IconEhternet },
          { text: '支持通过手机 App 进行门禁操作', icon: IconPhone },
          { text: '支持使用 NFC 卡片进行门禁操作', icon: IconCard },
          { text: '提供 1 年质保期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: '电磁锁',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: '插销锁',
            price: '150,000',
            img: deadboltThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: accessLiteThumb,
            title: 'Access Lite',
            price: '700,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    //얼굴 인식 출입
    face: {
      accesspro: {
        title: 'Access Pro',
        serial: 'KSB-SL02',
        price: '1,200,000',

        note: [
          { text: '支持通过手机实现非接触出入和视频通话功能', icon: IconInfo },
          { text: '最新版本的蓝牙技术', icon: IconBluetooth },
          { text: 'NFC卡出入', icon: IconCard },
          { text: '访客视频通话', icon: IconFacetime },
          { text: 'QR码出入', icon: IconQR },
          { text: '0 ~ 40°C工作温度', icon: IconTemp },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'EM Lock',
            price: '150,000',
            img: emlockThumb,
          },
          {
            title: '磁性门锁',
            price: '150,000',
            img: deadboltThumb,
          },
          {
            title: '室内自动门传感器',
            price: '99,000',
            img: accessAutoThumb,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: accessproThumbnail,
            title: 'Access Pro',
            price: '1,200,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    //출입 액세서리
    accessory: {
      accesskey: {
        title: 'Access Key',
        serial: 'KSB-AKC01',
        price: '30,000',

        note: [
          { text: '支持使用信标密钥进行非接触式出入功能', icon: IconInfo },
          { text: '最新版本的蓝牙技术', icon: IconBluetooth },
          { text: 'USB-C充电', icon: IconUsbc },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: accessKeyThumbnail,
            title: 'Access Key',
            price: '30,000',
            min: 1,
            max: 999,
          },
        ],
      },

      emlock: {
        title: 'EM Lock',
        serial: 'EM-Lock',
        price: '150,000',

        note: [
          { text: '电磁锁是一种主要用于防火门或木门等单向出入的电动锁，通过磁力将出入门固定的装置。', icon: '' },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: emlockThumbnail,
            title: 'EM Lock',
            price: '150,000',
            min: 1,
            max: 999,
          },
        ],
      },

      deadbolt: {
        title: '磁性门锁',
        serial: 'Deadbolt Lock',
        price: '150,000',
        note: [
          { text: '磁性门锁是一种在关闭门时自动锁定的自动锁定磁性门锁。可用于公寓，办公室等入口，大门等，可实现自动锁定。', icon: '' },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: deadboltThumbnail,
            title: '磁性门锁',
            price: '150,000',
            min: 1,
            max: 999,
          },
        ],
      },

      autoDoorSensor: {
        title: '室内自动门传感器',
        serial: 'Automatic Door Sensor',
        price: '99,000',
        note: [
          { text: '室内自动门传感器是一种用于控制类似于自动门的设备，可以检测人体或物体的移动，用于自动门的开闭。', icon: '' },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: ' ',

        mainProduct: [
          {
            img: accessAuto1,
            title: '室内自动门传感器',
            price: '99,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    ble: {
      twinTracker: {
        icon: twinTracker6,
        title: 'TwinTracker BLE',
        serial: 'OTR-TTBT0001',
        price: '400,000',

        note: [
          { text: '高性能蓝牙网关', icon: IconInfo },
          { text: '每秒扫描蓝牙设备 100 次', icon: IconSearchGray },
          { text: '支持“查找最近的标签”功能', icon: IconBinocularsGray },
          { text: '支持采集数据的序列输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 进行网络连接', icon: IconChainLinkGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: 'TwinTracker 安装支架', price: '150,000', img: twinTrackerBracket },
          { title: 'ORBRO 标签', price: '30,000', img: orbroTagThumb },
          { title: 'Plutocon 标签', price: '150,000', img: plutoconProThumb },
          { title: 'Coin 标签', price: '15,000', img: coinTagThumb },
          { title: 'Slim 标签', price: '15,000', img: slimTagThumb },
          { title: '贴纸标签', price: '15,000', img: stickerTagThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTracker6,
            title: 'TwinTracker BLE',
            price: '400,000',
            min: 1,
            max: 999,
          },
        ],
      },

      bleStarterKit: {
        icon: bleStarterKit,
        title: 'TwinTracker BLE 入门套件',
        serial: 'ORBRO Edge RTLS x 1 + L2 交换机 x 1 + TwinTracker BLE x 4',
        price: '2,500,000',

        note: [
          { text: '实时追踪 BLE 标签位置', icon: IconInfo },
          { text: '每秒扫描蓝牙设备 100 次', icon: IconSearchGray },
          { text: '支持“查找最近的标签”功能', icon: IconBinocularsGray },
          { text: '1 台 ORBRO Edge RTLS 可连接最多 8 个 TwinTracker', icon: IconEhternet },
          { text: '支持采集数据的序列输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 进行网络连接', icon: IconLinkChainGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: 'TwinTracker 安装支架', price: '150,000', img: twinTrackerBracket },
          { title: 'ORBRO 标签', price: '30,000', img: orbroTagThumb },
          { title: 'Plutocon 标签', price: '150,000', img: plutoconProThumb },
          { title: 'Coin 标签', price: '15,000', img: coinTagThumb },
          { title: 'Slim 标签', price: '15,000', img: slimTagThumb },
          { title: '贴纸标签', price: '15,000', img: stickerTagThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTracker6,
            title: 'TwinTracker BLE 入门套件',
            price: '2,500,000',
            min: 1,
            max: 999,
          },
        ],
      },

      bleEnterpriseKit: {
        icon: bleEnterpriseKit,
        title: 'TwinTracker BLE 企业套件',
        serial: 'ORBRO Server x 1 + L2 交换机 x 2 + ORBRO Edge RTLS x 2 + TwinTracker BLE x 12',
        price: '13,600,000',

        note: [
          { text: '基于 BLE 的实时定位系统', icon: IconInfo },
          { text: '每秒扫描蓝牙设备 100 次', icon: IconSearchGray },
          { text: '支持“查找最近的标签”功能', icon: IconBinocularsGray },
          { text: '1 台 ORBRO Edge RTLS 可连接最多 8 个 TwinTracker', icon: IconEhternet },
          { text: '通过 L2 交换机构建稳定网络', icon: IconEhternet },
          { text: '支持采集数据的序列输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 进行网络连接', icon: IconLinkChainGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: 'TwinTracker 安装支架', price: '150,000', img: twinTrackerBracket },
          { title: 'ORBRO 标签', price: '30,000', img: orbroTagThumb },
          { title: 'Plutocon 标签', price: '150,000', img: plutoconProThumb },
          { title: 'Coin 标签', price: '15,000', img: coinTagThumb },
          { title: 'Slim 标签', price: '15,000', img: slimTagThumb },
          { title: '贴纸标签', price: '15,000', img: stickerTagThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: bleStarterKit3,
            title: 'TwinTracker BLE 企业套件',
            price: '13,600,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    aoa: {
      twinTrackerAoa: {
        icon: twinTrackerAoa3,
        title: 'TwinTracker AoA',
        serial: 'OTR-TTAO0001',
        price: '700,000',

        note: [
          { text: 'AoA 蓝牙定位设备', icon: IconInfo },
          { text: '每秒扫描蓝牙设备 100 次', icon: IconSearchGray },
          { text: '支持“查找最近的标签”功能', icon: IconBinocularsGray },
          { text: '支持采集数据的序列输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 进行网络连接', icon: IconChainLinkGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker 安装支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTrackerAoaThumb,
            title: 'TwinTracker AoA',
            price: '700,000',
            min: 1,
            max: 999,
          },
        ],
      },

      aoaStarterKit: {
        icon: aoaStarterKitThumb,
        title: 'TwinTracker AoA 入门套件',
        serial: 'ORBRO Edge RTLS x 1 + L2 交换机 x 1 + TwinTracker AoA x 4',
        price: '3,700,000',

        note: [
          { text: '实时追踪 AoA 标签位置', icon: IconInfo },
          { text: '每秒扫描蓝牙设备 100 次', icon: IconSearchGray },
          { text: '支持“查找最近的标签”功能', icon: IconBinocularsGray },
          { text: '1 台 ORBRO Edge RTLS 可连接最多 8 个 TwinTracker', icon: IconEhternet },
          { text: '支持采集数据的序列输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 进行网络连接', icon: IconLinkChainGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: 'TwinTracker 导轨支架', price: '150,000', img: twinTrackerBracket },
          { title: 'ORBRO AoA 标签', price: '40,000', img: orbroTagThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: aoaStarterKitThumb,
            title: 'TwinTracker AoA 入门套件',
            price: '3,700,000',
            min: 1,
            max: 999,
          },
        ],
      },

      aoaEnterpriseKit: {
        icon: aoaEnterpriseKitThumb,
        title: 'TwinTracker AoA 企业套件',
        serial: 'ORBRO Server x 1 + L2 交换机 x 2 + ORBRO Edge RTLS x 2 + TwinTracker AoA x 12',
        price: '17,200,000',

        note: [
          { text: '实时追踪 AoA 标签位置', icon: IconInfo },
          { text: '每秒扫描蓝牙设备 100 次', icon: IconSearchGray },
          { text: '支持“查找最近的标签”功能', icon: IconBinocularsGray },
          { text: '1 台 ORBRO Edge RTLS 可连接最多 8 个 TwinTracker', icon: IconEhternet },
          { text: '通过 L2 交换机构建稳定网络', icon: IconEhternet },
          { text: '支持采集数据的序列输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 进行网络连接', icon: IconLinkChainGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: 'TwinTracker 导轨支架', price: '150,000', img: twinTrackerBracket },
          { title: 'ORBRO AoA 标签', price: '40,000', img: orbroTagThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: aoaEnterpriseKitThumb,
            title: 'TwinTracker AoA 企业套件',
            price: '17,200,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    uwb: {
      twinTrackerUwb: {
        icon: twinTracker6,
        title: 'TwinTracker UWB',
        serial: 'OTR-TTUW0001',
        price: '600,000',

        note: [
          { text: '支持使用 UWB 标签的高精度定位', icon: IconInfo },
          { text: '兼容 UWB 标签', icon: IconSearchGray },
          { text: '支持“查找最近标签”功能', icon: IconBinocularsGray },
          { text: '支持采集数据的串口输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 连接网络', icon: IconChainLinkGray },
          { text: '精度在 1 米以内，重复率高于 98%', icon: IconRulerGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker 导轨支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTracker6,
            title: 'TwinTracker UWB',
            price: '600,000',
            min: 1,
            max: 999,
          },
        ],
      },

      uwbStarterKit: {
        icon: uwbStarterKitThumb,
        title: 'TwinTracker UWB 入门套件',
        serial: 'ORBRO Edge RTLS x 1 + L2 交换机 x 1 + TwinTracker UWB x 4',
        price: '3,600,000',

        note: [
          { text: '支持使用 UWB 标签的高精度定位', icon: IconInfo },
          { text: '兼容 UWB 标签', icon: IconSearchGray },
          { text: '支持“查找最近标签”功能', icon: IconBinocularsGray },
          { text: '1 台 ORBRO Edge RTLS 最多可连接 8 个 TwinTracker UWB', icon: IconEhternet },
          { text: '支持采集数据的串口输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 连接网络', icon: IconLinkChainGray },
          { text: '精度在 1 米以内，重复率高于 98%', icon: IconRulerGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker 导轨支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'UWB 标签',
            price: '60,000',
            img: tagUwb1,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: uwbStarterKitThumb,
            title: 'TwinTracker UWB 入门套件',
            price: '3,600,000',
            min: 1,
            max: 999,
          },
        ],
      },

      uwbEnterpriseKit: {
        icon: aoaEnterpriseKitThumb,
        title: 'TwinTracker UWB 企业套件',
        serial: 'ORBRO Server x 1 + L2 交换机 x 2 + ORBRO Edge RTLS x 2 + TwinTracker UWB x 12',
        price: '17,200,000',

        note: [
          { text: '支持使用 UWB 标签的高精度定位', icon: IconInfo },
          { text: '兼容 UWB 标签', icon: IconSearchGray },
          { text: '支持“查找最近标签”功能', icon: IconBinocularsGray },
          { text: '1 台 ORBRO Edge RTLS 最多可连接 8 个 TwinTracker UWB', icon: IconEhternet },
          { text: '通过 L2 交换机构建稳定网络', icon: IconEhternet },
          { text: '支持采集数据的串口输出', icon: IconQR },
          { text: '通过以太网或 Wi-Fi 连接网络', icon: IconLinkChainGray },
          { text: '精度在 1 米以内，重复率高于 98%', icon: IconRulerGray },
          { text: '支持 PoE（以太网供电）标准', icon: IconEnergyCircleGray },
          { text: '提供 1 年保修期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'TwinTracker 导轨支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
          {
            title: 'UWB 标签',
            price: '60,000',
            img: tagUwb1,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: uwbEnterpriseKitThumb,
            title: 'TwinTracker UWB 企业套件',
            price: '17,200,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    comfort: {
      comfortKit: {
        icon: comfortKitThumb,
        title: 'Comfort Kit',
        serial: '移动App x 1 + UWB标签(Anchor) x 8 + UWB标签(RTLS)',
        price: '990,000',

        note: [
          { text: '便携式定位追踪设备', icon: IconInfo },
          { text: '随时随地轻松进行位置追踪', icon: IconSearchGray },
          { text: '提供基于手机的监控系统', icon: IconPhone },
          { text: '设备可作为锚点或标签自由使用', icon: IconCheckBlack },
          { text: '精度在3米以内，重复性高于98%', icon: IconRulerGray },
          { text: '续航约6小时', icon: IconEnergyCircleGray },
          { text: '提供1年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '0',

        mainProduct: [
          {
            img: comfortKitThumb,
            title: 'Comfort Kit',
            price: '990,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    gps: {
      gpsDevice: {
        icon: vehicleTrackingKitThumb,
        title: '车辆追踪套件',
        serial: 'ORBRO服务器 x 1 + GPS设备 x 5',
        price: '9,500,000',

        note: [
          { text: '用于户外资产和车辆定位的GNSS终端', icon: IconInfo },
          { text: '基于LTE-M进行位置数据通信', icon: IconUwbGray },
          { text: '±3米以内的定位精度', icon: IconRulerGray },
          { text: '每分钟最多10次位置上传（6秒间隔）', icon: IconSignal },
          { text: '支持BLE与NB-IoT通信选项', icon: IconSignal },
          { text: '内置LED状态指示灯', icon: IconSunGray },
          { text: 'IP等级防水防尘外壳', icon: IconWaterproof },
          { text: '可用于车辆安装或便携式使用', icon: IconCarGray },
          { text: 'USB Type-C 充电与数据接口', icon: IconEnergyCircleGray },
          { text: '支持多种卫星系统（GPS、GLONASS、北斗）', icon: IconLocationGray },
          { text: '提供1年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: vehicleTrackingKitThumb,
            title: '车辆追踪套件',
            price: '9,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    //작업자 위치 추적
    worker: {
      workerTracking: {
        icon: accessKey1,
        title: '工人定位套餐',
        serial: 'TwinTrackerPro 10 + Server 1',
        price: '11,000,000',

        note: [
          { text: '使用UWB定位器进行高精度定位', icon: IconInfo },
          { text: '精度在10cm以内', icon: IconWarn },
          { text: '每套包，室内最大安装面积为600平方米', icon: IconRoom },
          { text: '每套包，室外最大安装面积为1,000平方米', icon: IconRoom },
          { text: 'ORBRO服务器配备ORBRO OS', icon: IconComputer },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'TwinTracker Bracket',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server',
            price: '5,000,000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600,000',
            min: 10,
            max: 30,
          },
        ],
      },
      twinTrackerPro: {
        icon: twinTrackerThumbnail,
        title: 'TwinTracker Pro',
        serial: 'OTR-TTUW0001',
        price: '600,000',

        note: [
          { text: '使用UWB标签终端进行位置追踪', icon: IconInfo },
          { text: '以太网和Wi-Fi网络连接', icon: IconTopology },
          { text: 'PoE和USB Type-C电源供应', icon: IconPower },
          { text: '最高10cm精度', icon: IconRulerGray },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'TwinTracker Bracket',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: twinTrackerThumbnail,
            title: 'TwinTracker Pro',
            price: '600,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    lora: {
      gpsTag: {
        icon: yardTrackingKitThumb,
        title: '院区追踪套件',
        serial: 'ORBRO Server x 1 + LoRa网关 x 1 + GPS标签（LoRa）x 10',
        price: '11,500,000',

        note: [
          { text: '用于户外的 GNSS 定位追踪解决方案', icon: IconInfo },
          { text: '支持最长5公里的 LoRa 无线通信', icon: IconUwbGray },
          { text: '无需 LTE 通信（节省运营费用）', icon: IconUwbGray },
          { text: 'GNSS 定位精度 ±3 米以内', icon: IconRulerGray },
          { text: 'IP 等级防水防尘外壳', icon: IconWaterproof },
          { text: '针对大型院区/港口/工地优化设计', icon: IconRoom },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: yardTrackingKitThumb,
            title: '院区追踪套件',
            price: '11,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    server: {
      cameraEnterpriseKit: {
        icon: enterpriseKit1,
        title: 'ORBRO AI 服务器企业套件',
        serial: 'ORBRO AI Server x 1 + ORBRO Server',
        price: '19,000,000',

        note: [
          { text: '基于摄像头的视频位置追踪服务', icon: IconInfo },
          { text: '支持 RTSP 或 PoE 视频输入', icon: IconEhternet },
          { text: '最多可支持 6 台摄像设备的追踪', icon: IconCctvOff },
          { text: '需搭配 ORBRO Server 使用', icon: IconRoute2 },
          { text: '支持移动端服务', icon: IconPhone },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: '半球型摄像头', price: '1,600,000', img: ipCamReverse },
          { title: '云台摄像头（PTZ）', price: '4,000,000', img: ptzThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: enterpriseKit1,
            title: 'ORBRO AI 服务器企业套件',
            price: '19,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    edge: {
      cameraStarterKit: {
        icon: accessKey1,
        title: 'ORBRO Edge AI 入门套件',
        serial: 'ORBRO Edge AI x 1 + L2 交换机 x 1',
        price: '1,000,000',

        note: [
          { text: '基于摄像头的视频位置追踪服务', icon: IconInfo },
          { text: '支持 RTSP 或 PoE 视频输入', icon: IconEhternet },
          { text: '无需 ORBRO Server，可独立运行', icon: IconPhone },
          { text: '提供按时间段的访问分析功能', icon: IconRoute2 },
          { text: '支持人数统计（People Counting）功能', icon: IconUserCheck2 },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [
          { title: '半球型摄像头', price: '1,600,000', img: ipCamReverse },
          { title: '云台摄像头（PTZ）', price: '4,000,000', img: ptzThumb },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit2,
            title: 'ORBRO Edge AI 入门套件',
            price: '1,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    osServer: {
      osServer: {
        icon: osServer1,
        title: 'ORBRO 服务器',
        serial: 'ONT-SVNO5001',
        price: '7,000,000',

        note: [
          { text: '内置 ORBRO OS 的服务器设备', icon: IconInfo },
          { text: '提供管控中心功能', icon: IconEhternet },
          { text: '支持实时位置追踪界面', icon: IconLocationGray },
          { text: '支持 iOS、iPadOS、macOS、Web、Android 等平台', icon: IconAppsLineGray },
          { text: '支持用于位置数据分析的应用程序', icon: IconLayerGray },
          { text: '提供开发者平台', icon: IconCodeGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: osServer1,
            title: 'ORBRO 服务器',
            price: '7,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    osRtls: {
      osRtls: {
        icon: starterKit2,
        title: 'ORBRO Edge RTLS',
        serial: 'ONT-ERWF0001',
        price: '800,000',

        note: [
          { text: '内置 ORBRO OS 的 RTLS 设备', icon: IconInfo },
          { text: '支持 4 + 1 个端口', icon: IconEhternet },
          { text: '支持过电流保护和端口独立供电控制', icon: IconEnergyCircleGray },
          { text: '采用 RJ45 接口', icon: IconRoute2 },
          { text: '支持人数统计功能', icon: IconUserCheck2 },
          { text: '支持按时间段的流量分析', icon: IconAnalyticsGray },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit2,
            title: 'ORBRO Edge RTLS',
            price: '800,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    osAi: {
      osAi: {
        icon: enterpriseKit1,
        title: 'ORBRO Edge AI',
        serial: 'ONT-EAWF0001',
        price: '900,000',

        note: [
          { text: '基于摄像头的视频位置追踪服务', icon: IconInfo },
          { text: '支持 RTSP 或 PoE 视频输入', icon: IconEhternet },
          { text: '可独立运行，无需 ORBRO Server', icon: IconPhone },
          { text: '支持按时间段的流量分析', icon: IconRoute2 },
          { text: '支持人数统计功能', icon: IconUserCheck2 },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit2,
            title: 'ORBRO Edge AI',
            price: '900,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    osSwitch: {
      osSwitch: {
        icon: enterpriseKit1,
        title: 'L2 交换机',
        serial: 'ONT-LRBT5001',
        price: '100,000',

        note: [
          { text: 'ORBRO 专用 L2 交换机设备', icon: IconInfo },
          { text: '支持 8 个端口', icon: IconEhternet },
          { text: '支持过电流保护和每端口电源控制', icon: IconEnergyCircleGray },
          { text: '采用 RJ45 接口', icon: IconRoute2 },
          { text: '支持 1Gbps 上传速度', icon: IconPhone },
          { text: '提供 1 年保修', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: starterKit4,
            title: 'L2 交换机',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    //차량 위치 추적
    outdoor: {
      carTracking: {
        icon: accessKey1,
        title: '车辆定位套餐',
        serial: 'Server 1 + NVR 1 + PTZ Camera 2',
        price: '11,000,000',

        note: [
          { text: '通过PTZ摄像头追踪停车场车辆位置', icon: IconInfo },
          { text: '防护等级IP67防水防尘', icon: IconWaterproof },
          { text: '4MP高分辨率图像', icon: IconCamera },
          { text: '最大400m红外拍摄距离', icon: IconWarn },
          { text: '42倍光学，16倍数字变焦', icon: IconZoom },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server + NVR',
            price: '7,000,000',
            min: 1,
            max: 999,
          },
          {
            img: ptzThumb,
            title: 'PTZ Camera',
            price: '4,000,000',
            min: 2,
            max: 4,
          },
        ],
      },
      ptz: {
        icon: ptzThumb,
        title: 'PTZ Camera',
        serial: 'OTR-CAPT0001',
        price: '2,000,000',

        note: [
          { text: '通过PTZ摄像头追踪停车场车辆的位置。', icon: IconInfo },
          { text: '防护等级IP67防水防尘', icon: IconWaterproof },
          { text: '4MP高分辨率图像', icon: IconCamera },
          { text: '最大400m红外拍摄距离', icon: IconWarn },
          { text: '42倍光学，16倍数字变焦', icon: IconZoom },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: ptzThumb,
            title: 'PTZ Camera',
            price: '2,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    //유동 인구 위치 추적
    indoor: {
      peopleTracking: {
        icon: accessKey1,
        title: '人流分析套餐',
        serial: 'Server 1 + NVR 1 + IP Camera 4',
        price: '8,600,000',

        note: [
          { text: '通过室内IP摄像头追踪人员位置', icon: IconInfo },
          { text: '防护等级IP67防水防尘', icon: IconWaterproof },
          { text: '2MP高分辨率图像', icon: IconCamera },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '0',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO Server + NVR',
            price: '7,000,000',
            min: 1,
            max: 999,
          },
          {
            img: ipThumb,
            title: 'IP Camera',
            price: '1,600,000',
            min: 4,
            max: 8,
          },
        ],
      },
      ip: {
        icon: ipThumb,
        title: 'IP Camera',
        serial: 'OTR-CAIP0001',
        price: '1,600,000',

        note: [
          { text: '通过室内IP摄像头进行位置追踪和异常行为检测。', icon: IconInfo },
          { text: '防护等级IP67防水防尘', icon: IconWaterproof },
          { text: '2MP高分辨率图像', icon: IconCamera },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: ipThumb,
            title: 'IP Camera',
            price: '1,600,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    monitoring: {
      safetyBell: {
        icon: bell1,
        title: '安全铃',
        serial: 'KB-EW02',
        price: '100,000',

        note: [
          { text: '紧急情况下按下按钮向管理员发送短信报警', icon: IconInfo },
          { text: '最新版本的蓝牙', icon: IconBluetooth },
          { text: '通过Wi-Fi连接发送报警', icon: IconWifi },
          { text: '可发送100条报警短信', icon: IconMail },
          { text: '使用AAA电池', icon: IconBattery },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: safetyBellThumbnail,
            title: 'Safety Bell',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    energy: {
      smartSwitch: {
        icon: switch1,
        title: '智能开关',
        serial: 'KSB-SS01',
        price: '80,000',

        note: [
          { text: '远程可控智能开关', icon: IconInfo },
          { text: '蓝牙5.0', icon: IconBluetooth },
          { text: '通过手机应用控制照明', icon: IconPhone },
          { text: '非触碰触摸开关控制', icon: IconThumbUp },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: switchThumbnail,
            title: 'Smart Switch',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    display: {
      esl: {
        icon: esl1,
        title: 'ESL',
        serial: 'KI-MDE1',
        price: '80,000',

        note: [
          { text: '使用墨水显示信息', icon: IconInfo },
          { text: '蓝牙5.0', icon: IconBluetooth },
          { text: 'USB-C供电', icon: IconPower },
          { text: '230dpi分辨率', icon: IconEyeline },
          { text: 'NFC标签', icon: IconSignal },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: eslThumbnail,
            title: 'ESL',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    cradle: {
      mTag: {
        icon: mTagThumb,
        title: 'Mobile Tag',
        serial: 'KI-MT02',
        price: '80,000',

        note: [
          { text: '智能手机无线安全装置', icon: IconInfo },
          { text: '蓝牙5.2', icon: IconBluetooth },
          { text: '兼容iPhone、Android', icon: IconPhone },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        options: [
          { select: 'Lightning', imgIndex: 0 },
          { select: 'USB-C', imgIndex: 1 },
        ],

        parts: [],
        mark: '',

        mainProduct: [
          {
            img: mTagThumb,
            title: 'Mobile Tag',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },

      mCradle: {
        icon: mCradle1,
        title: 'Mobile Cradle',
        serial: 'KI-MC02',
        price: '80,000',

        note: [
          { text: '智能手机无线安全装置', icon: IconInfo },
          { text: '蓝牙5.2', icon: IconBluetooth },
          { text: 'USB-C充电', icon: IconPhone },
          { text: '1年质保期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '',

        mainProduct: [
          {
            img: mCradleThumb,
            title: 'Mobile Cradle',
            price: '80,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    idCard: {
      idCard: {
        icon: idCard1,
        title: 'ID02',
        serial: 'KB-ID02',
        price: '100,000',

        note: [
          { text: '基于蓝牙的电子员工证', icon: IconInfo },
          { text: '蓝牙 5.0', icon: IconBluetooth },
          { text: 'USB-C 供电', icon: IconPower },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        options: [],
        parts: [],
        mark: '',

        mainProduct: [
          {
            img: idCard1,
            title: 'ID02',
            price: '100,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    loraGateway: {
      loraGateway: {
        icon: loraGateway1,
        title: 'LoRa 网关',
        serial: 'ALESS-GW',
        price: '1,500,000',

        note: [
          { text: 'LoRa传感器终端的数据收集', icon: IconInfo },
          { text: 'IP67级防水防尘', icon: IconWaterproof },
          { text: '-20 ~ 60°C工业规格环境下运行', icon: IconTemp },
          { text: '24VDC电源供应', icon: IconPower },
          { text: '最大6km通信距离', icon: IconWarn },
          { text: '最多可容纳150个传感器', icon: IconSignal },
          { text: '可选择LTE/Wi-Fi通信', icon: IconWifi },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: loraGateway1,
            title: 'LoRa 网关',
            price: '1,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    loraSensor: {
      loraSensor: {
        icon: loraSensor1,
        title: 'LoRa 传感器',
        serial: 'ALESS-BA',
        price: '500,000',

        note: [
          { text: '支持通用输入传感器连接，支持多种传感器接口', icon: IconInfo },
          { text: 'IP67级防水防尘', icon: IconWaterproof },
          { text: '-20 ~ 60°C工业规格环境下运行', icon: IconTemp },
          { text: '可使用电池和外部DC24V供电', icon: IconPower },
          { text: '最大6km通信距离', icon: IconWarn },
          { text: '支持多种输入接口', icon: IconChainLinkGray },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [
          { select: '紧急铃', imgIndex: 0 },
          { select: '火警检测', imgIndex: 1 },
          { select: '温度/湿度', imgIndex: 0 },
          { select: '漏水检测', imgIndex: 1 },
          { select: '压力', imgIndex: 0 },
          { select: '入侵检测', imgIndex: 1 },
        ],

        mark: '2',

        mainProduct: [
          {
            img: loraSensor1,
            title: 'LoRa 传感器 - 紧急铃',
            price: '500,000',
            min: 1,
            max: 999,
          },
        ],
      },
      loraGateway: {
        icon: loraGateway1,
        title: 'LoRa 网关',
        serial: 'ALESS-GW',
        price: '1,500,000',

        note: [
          { text: 'LoRa传感器终端的数据收集', icon: IconInfo },
          { text: 'IP67级防水防尘', icon: IconWaterproof },
          { text: '-20 ~ 60°C工业规格环境下运行', icon: IconTemp },
          { text: '24VDC电源供应', icon: IconPower },
          { text: '最大6km通信距离', icon: IconWarn },
          { text: '最多可容纳150个传感器', icon: IconSignal },
          { text: '可选择LTE/Wi-Fi通信', icon: IconWifi },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: loraGateway1,
            title: 'LoRa 网关',
            price: '1,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    airQuality: {
      airQuality: {
        icon: mTagThumb,
        title: '空气质量测量仪',
        serial: 'VENTAX',
        price: '800,000',

        note: [
          { text: '工业用空气质量测量仪', icon: IconInfo },
          { text: '内置彩色LCD显示屏', icon: IconMonitorLineGray },
          { text: '支持RS-485和LoRa通信', icon: IconSignal },
          { text: '自动清洁功能', icon: IconToolsGray },
          { text: '韩国环境公园颁发的细颗粒物一级认证', icon: IconAtomGray },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],

        mark: '2',

        mainProduct: [
          {
            img: mTagThumb,
            title: '空气质量测量仪',
            price: '800,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    coMeasure: {
      coMeasure: {
        icon: mTagThumb,
        title: '一氧化碳测量仪',
        serial: 'VENTAX co+',
        price: '1,500,000',

        note: [
          { text: '一氧化碳和空气质量测量仪', icon: IconInfo },
          { text: '支持RS-485和Wi-Fi通信', icon: IconSignal },
          { text: '微粒子、一氧化碳、温度/湿度测量', icon: IconTvocGray },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],

        mark: '0',

        mainProduct: [
          {
            img: mTagThumb,
            title: '一氧化碳测量仪',
            price: '1,500,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    beaconIndustry: {
      plutoconPro: {
        icon: mTagThumb,
        title: 'Plutocon Pro',
        serial: 'KB-BK02',
        price: '50,000',

        note: [
          { text: '工业用Beacon终端', icon: IconInfo },
          { text: '最新版本的蓝牙', icon: IconBluetooth },
          { text: 'IP65级防水防尘(-10 ~ 60°C)', icon: IconWaterproof },
          { text: '最长3年电池使用寿命', icon: IconBattery },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],

        mark: '0',

        mainProduct: [
          {
            img: mTagThumb,
            title: 'Plutocon Pro',
            price: '50,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },
    beaconTag: {
      orbroTag: {
        icon: mTagThumb,
        title: 'ORBRO标签',
        serial: 'OAS-OTBT1991',
        price: '30,000',

        note: [
          { text: '小型Beacon终端', icon: IconInfo },
          { text: '最新版本的蓝牙', icon: IconBluetooth },
          { text: 'IP65级防水防尘(-10 ~ 60°C)', icon: IconWaterproof },
          { text: '最长2年电池使用寿命', icon: IconBattery },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],

        mark: '0',

        mainProduct: [
          {
            img: mTagThumb,
            title: 'ORBRO标签',
            price: '30,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    assetTag: {
      assetTag: {
        icon: assetTag1,
        title: 'Asset Tag (1,000EA)',
        serial: 'OAS-ABBT1991',
        price: '20,000,000',

        note: [
          { text: '用于资产管理的超小型信标终端', icon: IconInfo },
          { text: '最新版本的蓝牙', icon: IconBluetooth },
          { text: '最长1年的电池使用期限', icon: IconBattery },
          { text: '1年保修期', icon: IconGuarantee },
        ],

        parts: [],
        options: [],

        mark: '2',

        mainProduct: [
          {
            img: assetTag1,
            title: 'Asset Tag (1,000EA)',
            price: '20,000,000',
            min: 1,
            max: 999,
          },
        ],
      },
    },

    robot: {
      robotBasic: {
        icon: accessKey1,
        title: '配送机器人基本套装',
        serial: '配送机器人 + TwinTrackerPro 10 + 服务器 1',
        price: '价格另询',

        note: [
          { text: '室内定位系统与机器人系统的协调，简单配置实现快速部署', icon: IconInfo },
          { text: '配送机器人载重量 20L', icon: IconWaterproof },
          { text: '精度在10cm以内', icon: IconCamera },
          { text: '室内最大安装面积600平方米', icon: IconGuarantee },
          { text: '室外最大安装面积1,000平方米', icon: IconGuarantee },
          { text: 'ORBRO服务器包含ORBRO OS', icon: IconGuarantee },
        ],

        parts: [
          {
            title: '标签（UWB）',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'TwinTracker 导轨支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO 服务器',
            price: '5,000,000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600,000',
            min: 100,
            max: 300,
          },
          {
            img: ipThumb,
            title: '配送机器人',
            price: '价格另询',
            min: 1,
            max: 10,
          },
        ],
      },

      delivery: {
        icon: accessKey1,
        title: '无人装卸包',
        serial: '配送机器人 + 装载终端 + 协作机器人 + TwinTrackerPro 10 + 服务器 1',
        price: '价格另询',

        note: [
          { text: '使配送机器人能够无人装卸的套装', icon: IconInfo },
          { text: '配送机器人载重量 20L', icon: IconWaterproof },
          { text: '协作机器人最大负载 12kg', icon: IconCamera },
          { text: '精度在10cm以内', icon: IconGuarantee },
          { text: '室内最大安装面积600平方米', icon: IconGuarantee },
          { text: '室外最大安装面积1,000平方米', icon: IconGuarantee },
          { text: 'ORBRO服务器包含ORBRO OS', icon: IconGuarantee },
        ],

        parts: [
          {
            title: '标签（UWB）',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'TwinTracker 导轨支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO 服务器',
            price: '5,000,000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600,000',
            min: 100,
            max: 300,
          },
          {
            img: ipThumb,
            title: '配送机器人',
            price: '价格另询',
            min: 1,
            max: 10,
          },
          {
            img: ipThumb,
            title: '装载终端',
            price: '价格另询',
            min: 1,
            max: 10,
          },
          {
            img: ipThumb,
            title: '协作机器人',
            price: '价格另询',
            min: 1,
            max: 10,
          },
        ],
      },

      disinfection: {
        icon: accessKey1,
        title: '高风险管理包',
        serial: '配送机器人 + 装载终端 + 协作机器人 + 消毒设备 + 其他',
        price: '价格另询',

        note: [
          { text: '配置用于管理高风险医疗物品配送的套装', icon: IconInfo },
          { text: '配送机器人载重量 20L', icon: IconWaterproof },
          { text: '协作机器人最大负载 12kg', icon: IconCamera },
          { text: '99.9%的消毒和灭菌', icon: IconGuarantee },
          { text: '精度在10cm以内', icon: IconGuarantee },
          { text: '室内最大安装面积600平方米', icon: IconGuarantee },
          { text: '室外最大安装面积1,000平方米', icon: IconGuarantee },
          { text: 'ORBRO服务器包含ORBRO OS', icon: IconGuarantee },
        ],

        parts: [
          {
            title: '标签（UWB）',
            price: '60,000',
            img: tagUwb1,
          },
          {
            title: 'TwinTracker 导轨支架',
            price: '150,000',
            img: twinTrackerBracket,
          },
        ],
        options: [],
        mark: '2',

        mainProduct: [
          {
            img: orbroServerThumbnail,
            title: 'ORBRO 服务器',
            price: '5,000,000',
            min: 1,
            max: 999,
          },
          {
            img: twinTrackerThumbnail,
            title: 'TwinTrackerPro',
            price: '600,000',
            min: 100,
            max: 300,
          },
          {
            img: ipThumb,
            title: '配送机器人',
            price: '价格另询',
            min: 1,
            max: 10,
          },
          {
            img: ipThumb,
            title: '装载终端',
            price: '价格另询',
            min: 1,
            max: 10,
          },
          {
            img: ipThumb,
            title: '协作机器人',
            price: '价格另询',
            min: 1,
            max: 10,
          },
          {
            img: ipThumb,
            title: '消毒设备套件',
            price: '价格另询',
            min: 1,
            max: 10,
          },
        ],
      },
    },
  },

  modal: {
    title: '产品咨询',
    descHead: '请填写以下信息，我们的负责人将通过邮箱发送给您报价单。',
    descMid: '如果您需要快速回复，请拨打电话',
    phone: '1522-9928',
    descTail: '，我们将非常感谢。',
    time: '工作日（10:00 - 19:00）',

    theme: {
      name: '姓名 *',
      company: '公司名称 *',
      email: '工作用电子邮箱 *',
      phone: '联系电话',
    },
    placeholder: {
      name: '张三',
      company: 'ORBRO股份有限公司',
      email: 'example@orbro.io',
      phone: '010-1234-5678',
      ask: '请填写其他咨询内容。（选填）',
    },
  },

  accessory: '配件',
  soldOut: '售罄',
  new: '新产品',
  request: '产品咨询',
  select: '选择',

  submit: '提交',
  cancel: '取消',
};
